import Pusher from 'pusher-js'
import type { ChannelAuthorizationOptions } from 'pusher-js/types/src/core/auth/options'

import { getAccessToken } from 'common/store/api/fetchBaseQuery'
import { env } from 'common/utils/env'

import { TEAM_AUTH_PATH, TEAM_PUSHER } from './teamSocket.constants'

export type TeamSocketConfig = {
  key: string
  cluster: string
  apiBaseUrl: string
  getToken: () => string
}

const TRAILING_SLASHES = /\/+$/

export const teamChannelName = (doctorId: number): string => `private-team.${doctorId}`
export const presenceChannelName = (doctorId: number): string => `presence-team.${doctorId}`

export const readTeamSocketConfig = (): TeamSocketConfig => ({
  key: TEAM_PUSHER.key,
  cluster: TEAM_PUSHER.cluster,
  apiBaseUrl: env.RESIDEN_API_BASE_URL,
  getToken: getAccessToken,
})

const channelAuthorization = (config: TeamSocketConfig): ChannelAuthorizationOptions => ({
  endpoint: `${config.apiBaseUrl.replace(TRAILING_SLASHES, '')}${TEAM_AUTH_PATH}`,
  transport: 'ajax',
  headersProvider: () => ({ Authorization: `Bearer ${config.getToken()}` }),
})

export const createTeamSocket = (
  config: TeamSocketConfig = readTeamSocketConfig(),
): Pusher | null => {
  if (!config.key || !config.cluster) return null
  return new Pusher(config.key, {
    cluster: config.cluster,
    forceTLS: true,
    channelAuthorization: channelAuthorization(config),
  })
}
